// extracted by mini-css-extract-plugin
export default {"contentview":"c1ef4cd78d40b22c3613"};